import moment from 'moment';
import * as constAction from 'root/actionConstants';

export const clear = (payload) => ({
  type: constAction.PENALIZACIONES_CLEAR,
  payload,
});

export const setState = (payload) => ({
  type: constAction.PENALIZACIONES_SET_STATE,
  payload,
});

export const solucionar = (penalizacionId, pago, solucionado, closeModal) => ({
  type: constAction.PENALIZACIONES_SOLUCIONAR,
  payload: { penalizacionId, pago, solucionado },
  epic: {
    url: 'penalizaciones/solucionar',
    method: 'POST',
  },
});

export const solucionarTodas = (usuarioId, pago) => ({
  type: constAction.PENALIZACIONES_SOLUCIONAR_TODAS,
  payload: { usuarioId, pago },
  epic: {
    url: 'penalizaciones/solucionarTodas',
    method: 'POST',
  },
});

export const get = (solucionado, pago, documentoUsuario, fecha, skip) => {
  let data = {
    type: constAction.PENALIZACIONES_GET,
    payload: { solucionado, pago, documentoUsuario: documentoUsuario && Number(documentoUsuario), fecha, skip },
    epic: {
      url: 'penalizaciones/getAll',
      method: 'GET',
    },
  };

  return data;
};



// WEBPACK FOOTER //
// src/modules/penalizaciones/action.js